<div class="row row-header">
	<div class="col">

		<h1 data-testid="SUBSYS5_HISTORY_TITLE_TXT" class="mb-5">{{ labels().HISTORY_COMPONENT_TITLE }}</h1>

		<div class="panel mb-0">
			<h4 data-testid="SUBSYS5_HISTORY_PATIENT_TXT" class="wrapper-title-span">
				{{ labels().HISTORY_COMPONENT_TITLE_PATIENT_ID }}:<span>{{ patient()?.number }}</span>
			</h4>
		</div>

	</div>
</div>

<div class="row row-contents">
	<div class="col">

		<div class="mt-5">
			<tsp-syncronization [lastSync]="lastSync()" />
		</div>

		<div class="mt-5">
			<tsp-anomaly-table [isReadonly]="isReadonly()" />
		</div>

		<div class="my-5">
			<tsp-diary-table [isReadonly]="isReadonly()" />
		</div>

		<div class="bottom-bar-save bottom-bar-save-plan">
			<button data-testid="SUBSYS5_HISTORY_CANCEL_BTN" type="button" class="btn btn-secondary-outline"
				(click)="cancel()">
				{{ labels().HISTORY_COMPONENT_COMPONENT_CANCEL_BUTTON }}
			</button>
		</div>

	</div>
</div>